import React from "react";
import { useTranslation } from "react-i18next";

function AuthenticateErrModal(props) {
  const { t } = useTranslation();
  return <p className="notificationText">{t("apiErrors.err401")}</p>;
}

export default AuthenticateErrModal;
